


















import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Config from "../../../store/entities/config";
@Component
export default class EditConfig extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  item: Config = new Config();
  created() {}
  save() {
    (this.$refs.form as any).validate(async (valid: boolean) => {
      if (valid) {
        await this.$store.dispatch({
          type: "config/update",
          data: this.item
        });
        (this.$refs.form as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.form as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.item = new Config();
      this.$emit("input", value);
    } else {
      if (this.$store.state.config.editConfig) {
        this.item = Util.extend({}, this.$store.state.config.editConfig);
      }
    }
  }
  rule = {
    name: [
      {
        required: true,
        message: this.L("Error.RequiredField", undefined, this.L("Name")),
        trigger: "blur"
      }
    ],
    value: [
      {
        required: true,
        message: this.L("Error.RequiredField", undefined, this.L("Value")),
        trigger: "blur"
      }
    ]
  };
}
